import React from 'react';
import { graphql, withApollo, compose } from 'react-apollo';
import { Loader, Dimmer } from 'semantic-ui-react';
import { uploadFile } from '../../utils/fileUploader';
import { CreateDocument } from '../../mutations/CreateDocument';
import { DestroyDocument } from '../../mutations/DestroyDocument';
import { UpdateDocument } from '../../mutations/UpdateDocument';
import CropImage from '../CropImage';
import Content from '../Content';
import PathView from '../PathView';
import DocumentTitle from '../DocumentTitle';
import _ from 'lodash';

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  handleDocumentFileSelected = (files, passengerTicketId, index = 0) => {
    const claim = this.props.data.claim || {};
    this.setState({ loading: true });
    this.props
      .CreateDocument({
        variables: {
          input: {
            document: {
              status: 'accepted'
            },
            claimsPassengerTicket: {
              claimId: claim.id,
              passengerTicketId
            }
          }
        }
      })
      .then(({ data }) => {
        const documentId = data.createDocument.document.id;
        const xhr = new XMLHttpRequest();
        xhr.onload = data => {
          this.props.data.refetch();
        };
        xhr.onloadend = () => {
          this.setState({ loading: false });
          this.props.showMessage({
            header: 'Success',
            text: 'Document added',
            props: { success: true },
            duration: 2000
          });
        };
        uploadFile(xhr, files[index], '/documents/' + documentId + '/uploads');
        if (++index < files.length) {
          return Promise.resolve(
            this.handleDocumentFileSelected(files, passengerTicketId, index)
          );
        }
      })
      .catch(error => {
        console.error(error);
        this.setState({ loading: false });
      });
  };

  handleCropComplete = (image, originalDocument) => {
    const claim = this.props.data.claim || {};
    this.setState({ loading: true });
    this.props
      .CreateDocument({
        variables: {
          input: {
            document: {
              documentId: originalDocument.id,
              status: 'accepted'
            },
            claimsPassengerTicket: {
              passengerTicketId:
                originalDocument.claimsPassengerTicket.passengerTicket.id,
              claimId: claim.id
            }
          }
        }
      })
      .then(({ data }) => {
        const xhr = new XMLHttpRequest();
        const id = data.createDocument.document.id;
        xhr.onload = () => {
          this.props.data.refetch();
        };
        xhr.onloadend = () => {
          this.setState({ loading: false });
        };
        uploadFile(xhr, image, '/documents/' + id + '/uploads');
      })
      .catch(error => {
        this.setState({ loading: false });
        console.error(error);
      });
  };

  handleCroppedDocumentRotated = (image, document) => {
    this.setState({ loading: true });
    const xhr = new XMLHttpRequest();
    xhr.onload = () => this.props.data.refetch();
    xhr.onloadend = () => this.setState({ loading: false });
    uploadFile(xhr, image, '/documents/' + document.id + '/uploads');
  };

  handleDocumentTypeChanged = (type, document) => {
    this.setState({ loading: true });
    this.props
      .UpdateDocument({
        variables: {
          input: {
            document: {
              id: document.id,
              type: String(type.value)
            }
          }
        }
      })
      .then(({ data }) => {
        this.onUpdateDocumentSuccess(data);
      })
      .catch(error => {
        this.setState({ loading: false });
      });
  };

  handleDocumentRemoved = document => {
    this.setState({ loading: true });
    this.props
      .DestroyDocument({
        variables: {
          input: {
            id: document.id
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        this.props.data.refetch();
        this.props.showMessage({
          header: 'Success',
          text: 'Document removed',
          props: { success: true },
          duration: 2000
        });
      })
      .catch(error => {
        this.setState({ loading: false });
      });
  };
  handleDocumentAssignedPassengerChanged = (claimPassengerTicket, document) => {
    this.setState({ loading: true });
    this.props
      .UpdateDocument({
        variables: {
          input: {
            document: {
              id: document.id,
              status: 'accepted'
            },
            claimsPassengerTicket: {
              passengerTicketId: claimPassengerTicket.passengerTicket.id,
              claimId: this.props.data.claim.id
            }
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        this.props.data.refetch();
      })
      .catch(error => {
        this.setState({ loading: false });
      });
  };

  onUpdateDocumentSuccess = data => {
    const { updateSelectedDocuments } = this.props;
    this.setState({ loading: false });
    if (updateSelectedDocuments) {
      this.props.refetchClaimWithDocuments();
      const { id, type, documentValid } = _.get(
        data,
        'updateDocument.document'
      );
      updateSelectedDocuments(id, type, documentValid);
    }
  };

  render = () => {
    const {
      passengers,
      data,
      data: { claim }
    } = this.props;
    const loading = this.props.loading || data.loading || this.state.loading;
    return (
      <Content fullWidth>
        <DocumentTitle
          title={`Claim ${_.get(this.props, 'match.params.id')}`}
        />
        <Dimmer active={loading} inverted page>
          <Loader size="massive" />
        </Dimmer>
        <PathView
          paths={[
            { name: 'Claims', path: '/claims' },
            {
              name: this.props.data.variables.id,
              path: `/claim/${this.props.data.variables.id}`
            },
            { name: 'Documents' }
          ]}
        />
        <CropImage
          selectedDocuments={this.props.selectedDocuments}
          errorDocuments={this.props.errorDocuments}
          updateSelectedDocuments={this.props.updateSelectedDocuments}
          editDisabled={this.props.editDisabled}
          onFilesSelected={this.handleDocumentFileSelected.bind(this)}
          onCropComplete={this.handleCropComplete.bind(this)}
          disableCropping={this.props.disableCropping}
          onDocumentRotated={this.handleCroppedDocumentRotated.bind(this)}
          onDocumentTypeChanged={this.handleDocumentTypeChanged.bind(this)}
          onDocumentRemoved={this.handleDocumentRemoved.bind(this)}
          onDocumentAssignedPassengerChanged={this.handleDocumentAssignedPassengerChanged.bind(
            this
          )}
          loading={this.state.loading}
          claim={claim}
          passengers={passengers}
          onlyOneDocument={this.props.onlyOneDocument}
          onUpdateDocumentSuccess={this.onUpdateDocumentSuccess}
        />
      </Content>
    );
  };
}

export default compose(
  withApollo,
  graphql(CreateDocument, { name: 'CreateDocument' }),
  graphql(UpdateDocument, { name: 'UpdateDocument' }),
  graphql(DestroyDocument, { name: 'DestroyDocument' })
)(Documents);



// WEBPACK FOOTER //
// ./src/component/Documents/DocumentsView.js